<template>
  <div class="auth">
    <div class="center">
      <div class="text">正在进入平台，请稍候...</div>
    </div>
  </div>
</template>

<script>
import { loginWithQrcode } from "@/api/common";

export default {
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  watch: {
    $route: {
      handler: function (val) {
        const { code } = val.query;
        if (code) {
          loginWithQrcode(code).then((data) => {
            this.$store.commit("login", data);
            this.$router.push({
              path: "/",
              replace: true,
            });
          });
        } else {
          this.$router.push({
            path: "/",
            replace: true,
          });
        }
      },
      immediate: true,
    },
  },
  beforeRouteEnter(to, from, next) {
    document.title = "加载中";
    next();
  },
  beforeRouteLeave(to, from, next) {
    document.title = "银行汇票管理系统";
    next();
  },
};
</script>

<style scoped>
.auth {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.auth .center {
  transform: scale(0.6);
  width: 200px;
  height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.auth .center .text {
  margin-top: 24px;
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  color: #3c4858;
  font-size: 26px;
  height: 1.6em;
  line-height: 1.6;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/auth.vue